export const ALLERGENS = {
  "1": "Cereals (gluten)",
  "2": "Crustaceans",
  "3": "Eggs",
  "4": "Fish",
  "5": "Peanuts",
  "6": "Soybeans",
  "7": "Milk (lactose)",
  "8": "Nuts",
  "9": "Celery",
  "10": "Mustard",
  "11": "Sesame seeds",
  "12": "Sulphites",
  "13": "Lupin",
  "14": "Molluscs",
};

export const formatAllergens = (codes = []) =>
  codes.length ? `Allergens: ${codes.join(", ")}` : "";
